<div class="wrapper cl-shell">
  <!-- thin page-load bar across the very top: runs while a route is loading (driven from initClarityShell) -->
  <div class="cl-progress" #clProgress></div>
  <!-- ========== Left Sidebar Start ========== -->
  <div class="leftside-menu">
    <!-- LOGO -->
    <a href="index.html" class="logo text-center logo-light">
      <span class="logo-lg">
        <img [src]="whiteLabelDetails ? whiteLabelDetails.companyLogo : ''" alt="" height="55" style="width: auto; max-width: 100%; object-fit: contain;" />
      </span>
      <span class="logo-sm">
        <img [src]="whiteLabelDetails ? whiteLabelDetails.smallLogoUrl : ''" alt="" height="40" />
      </span>
    </a>

    <!-- Menu search (Ctrl+K): opens the command palette at the end of this template -->
    <div class="cl-menu-search">
      <button type="button" class="cl-menu-search-btn" (click)="openCmd()" title="Search menu (Ctrl+K)">
        <i class="mdi mdi-magnify"></i><span class="cl-t">Search menu...</span><kbd>Ctrl K</kbd>
      </button>
    </div>

    <!-- Scroll container — no data-simplebar so no overflow:hidden wrappers blocking flyouts -->
    <div class="sidebar-scroll-area" id="leftside-menu-container" [ngClass]="{ 'myhome-scroll': isSidebarEnabled }">
      <div class="cl-indicator" #clIndicator></div>
      <ul class="side-nav">
        <li class="side-nav-item" *ngFor="let menu of parentMenu; let i = index" (mouseenter)="onMenuHover(i, $event)"
          (mouseleave)="onMenuLeave()">

          <!-- Parent link: navigate directly if no children, otherwise expand accordion -->
          <a class="side-nav-link d-flex align-items-center justify-content-start"
            [routerLink]="(!menu.childMenuList || menu.childMenuList.length === 0) ? [menu.subRoleCode] : null"
            (click)="(!menu.childMenuList || menu.childMenuList.length === 0) ? null : toggleMenu(i)"
            [class.menu-open]="expandedMenuIdx === i"
            [class.cl-current]="isModuleCurrent(menu)"
            [class.cl-src]="!isSidebarEnabled && hoveredMenuIdx === i">
            <i [class]="menu.menuIconUrl"></i>
            <span>{{ menu.subRoleName }}</span>
            <span class="menu-arrow" *ngIf="menu.childMenuList && menu.childMenuList.length > 0"></span>
          </a>

          <!-- Second level (always rendered, so collapsing the menu does not rebuild it; hidden by CSS in the collapsed rail) -->
          <div class="menu-submenu" [class.menu-submenu-open]="expandedMenuIdx === i">
            <ul class="side-nav-second-level">
              <li class="side-nav-item" *ngFor="let child of menu.childMenuList; let ci = index">

                <ng-container
                  *ngIf="child.childMenuList && child.childMenuList.length > 0 && !child.childIsParent; else leafChild2">
                  <a class="d-flex align-items-center justify-content-between" (click)="toggleChild(i + '-' + ci)"
                    [class.menu-open]="expandedChildKey === (i + '-' + ci)">
                    {{ child.subRoleName }}
                    <span class="menu-arrow"></span>
                  </a>
                  <div class="menu-submenu" [class.menu-submenu-open]="expandedChildKey === (i + '-' + ci)">
                    <ul class="side-nav-third-level">
                      <li *ngFor="let sub of child.childMenuList; let si = index">
                        <ng-container *ngIf="sub.childMenuList && sub.childMenuList.length > 0; else leafSub">
                          <a class="d-flex align-items-center justify-content-between"
                            (click)="toggleChild(i + '-' + ci + '-' + si)"
                            [class.menu-open]="expandedChildKey === (i + '-' + ci + '-' + si)">
                            {{ sub.subRoleName }}
                            <span class="menu-arrow"></span>
                          </a>
                          <div class="menu-submenu"
                            [class.menu-submenu-open]="expandedChildKey === (i + '-' + ci + '-' + si)">
                            <ul class="side-nav-fourth-level">
                              <li *ngFor="let fourth of sub.childMenuList">
                                <a
                                  [routerLink]="[menu.subRoleCode, child.subRoleCode, sub.subRoleCode, fourth.subRoleCode]"
                                  routerLinkActive="cl-active">
                                  {{ fourth.subRoleName }}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </ng-container>
                        <ng-template #leafSub>
                          <a [routerLink]="[menu.subRoleCode, child.subRoleCode, sub.subRoleCode]" routerLinkActive="cl-active">
                            {{ sub.subRoleName }}
                          </a>
                        </ng-template>
                      </li>
                    </ul>
                  </div>
                </ng-container>

                <ng-template #leafChild2>
                  <a [routerLink]="[menu.subRoleCode, child.subRoleCode]" routerLinkActive="cl-active">
                    {{ child.subRoleName }}
                  </a>
                </ng-template>

              </li>
            </ul>
          </div>

        </li>
      </ul>
    </div>

    <!-- Condensed mode flyout panel.
         position:fixed is used so it escapes ALL overflow containers.
         Rendered as a sibling of the scroll area, OUTSIDE #leftside-menu-container. -->
    <ng-container *ngIf="!isSidebarEnabled && hoveredMenu">
      <!-- pointer notch: a small arrow between the rail icon and the card, aimed at the hovered icon (positioned in initClarityShell) -->
      <div class="cl-fl-notch" (mouseenter)="onFlyoutEnter()" (mouseleave)="onFlyoutLeave()"></div>
      <div class="sidebar-flyout" [style.top.px]="flyoutY" (mouseenter)="onFlyoutEnter()"
        (mouseleave)="onFlyoutLeave()">
        <div class="flyout-header"><i [class]="hoveredMenu!.menuIconUrl"></i>{{ hoveredMenu!.subRoleName }}</div>
        <ul>
          <li class="flyout-item" *ngFor="let child of hoveredMenu!.childMenuList; let ci = index"
            (mouseenter)="flyoutHoveredChildIdx = ci; clPlaceSub($event)" (mouseleave)="flyoutHoveredChildIdx = null">

            <ng-container
              *ngIf="child.childMenuList && child.childMenuList.length > 0 && !child.childIsParent; else flyoutLeaf">
              <a class="flyout-link has-children">
                {{ child.subRoleName }}
                <i class="mdi mdi-chevron-right flyout-arrow"></i>
              </a>
              <ul class="flyout-level2" *ngIf="flyoutHoveredChildIdx === ci">
                <li class="flyout-item" *ngFor="let sub of child.childMenuList; let si = index"
                  (mouseenter)="flyoutHoveredSubIdx = si; clPlaceSub($event)" (mouseleave)="flyoutHoveredSubIdx = null">
                  <ng-container *ngIf="sub.childMenuList && sub.childMenuList.length > 0; else flyoutSubLeaf">
                    <a class="flyout-link has-children">
                      {{ sub.subRoleName }}
                      <i class="mdi mdi-chevron-right flyout-arrow"></i>
                    </a>
                    <ul class="flyout-level3" *ngIf="flyoutHoveredSubIdx === si">
                      <li *ngFor="let fourth of sub.childMenuList">
                        <a class="flyout-link"
                          [routerLink]="[hoveredMenu!.subRoleCode, child.subRoleCode, sub.subRoleCode, fourth.subRoleCode]"
                          (click)="closeFlyout()">
                          {{ fourth.subRoleName }}
                        </a>
                      </li>
                    </ul>
                  </ng-container>
                  <ng-template #flyoutSubLeaf>
                    <a class="flyout-link" [routerLink]="[hoveredMenu!.subRoleCode, child.subRoleCode, sub.subRoleCode]"
                      (click)="closeFlyout()">
                      {{ sub.subRoleName }}
                    </a>
                  </ng-template>
                </li>
              </ul>
            </ng-container>

            <ng-template #flyoutLeaf>
              <a class="flyout-link" [routerLink]="[hoveredMenu!.subRoleCode, child.subRoleCode]"
                (click)="closeFlyout()">
                {{ child.subRoleName }}
              </a>
            </ng-template>

          </li>
        </ul>
      </div>
    </ng-container>

    <!-- Sidebar collapse/expand toggle -->
    <ul class="position-absolute bottom-0 w-100 d-none d-md-block border-top text-end px-2 mb-0"
      style="background: var(--bs-white); cursor: pointer;">
      <span class="mdi mdi-chevron-double-left mdi-36px" *ngIf="isSidebarEnabled" style="cursor: pointer;"></span>
      <span class="mdi mdi-chevron-double-right mdi-36px" *ngIf="!isSidebarEnabled" style="cursor: pointer;"></span>
    </ul>

    <!-- Sticky brand footer at the bottom of the menu (replaces the page footer) -->
    <div class="cl-menu-foot">
      <span class="cl-mf-by">powered by</span>
      <a href="https://www.advinsoftwares.com/" target="_blank" rel="noopener">
        <span class="cl-mf-full">Advin Softwares Pvt Ltd</span><span class="cl-mf-short">Advin</span>
      </a>
    </div>
  </div>
  <!-- Left Sidebar End -->

  <!-- Menu search (command palette), opened by the search buttons or Ctrl+K -->
  <div class="cl-cmdk" *ngIf="cmdOpen" (mousedown)="closeCmd()">
    <div class="cl-cmdk-box" (mousedown)="$event.stopPropagation()">
      <div class="cl-cmdk-in">
        <i class="mdi mdi-magnify"></i>
        <input #clCmdInput type="text" [value]="cmdQuery" (input)="onCmdInput($event)" (keydown)="onCmdKey($event)"
          placeholder="Search any menu or page..." autocomplete="off" spellcheck="false" />
        <kbd>Esc</kbd>
      </div>
      <div class="cl-cmdk-list" #clCmdList>
        <ng-container *ngIf="cmdResults.length; else clNoResults">
          <ng-container *ngFor="let item of cmdResults; let i = index; trackBy: trackCmd">
            <div class="cl-cmdk-grp" *ngIf="i === 0 || cmdResults[i - 1].group !== item.group">{{ item.group }}</div>
            <div class="cl-cmdk-it" [class.sel]="i === cmdIndex" (mousemove)="onCmdMouseMove(i)" (click)="runCmd(item)">
              <span class="cl-ci"><i [class]="item.icon"></i></span>
              <span>{{ item.label }}</span>
              <span class="cl-path">{{ item.trail }}</span>
            </div>
          </ng-container>
        </ng-container>
        <ng-template #clNoResults><div class="cl-cmdk-empty">No matching pages</div></ng-template>
      </div>
      <div class="cl-cmdk-foot"><span><kbd>&uarr;</kbd> <kbd>&darr;</kbd> move</span><span><kbd>Enter</kbd> open</span><span><kbd>Esc</kbd> close</span></div>
    </div>
  </div>

  <!-- User dropdown portal — outside leftside-menu, escapes overflow/stacking context -->
  <ng-container *ngIf="userDropdownOpen">
    <div class="sidebar-user-dropdown-backdrop" (click)="closeUserDropdown()"></div>
    <div class="dropdown-menu show sidebar-dropdown-menu cl-ud" [ngStyle]="userDropdownStyle">
      <!-- who is signed in (display only) -->
      <div class="cl-ud-head">
        <span class="cl-ud-avatar">
          <img *ngIf="User.profileImage; else clInitialsUd" [src]="User.profileImage" (error)="onImageError($event)" alt="" />
          <ng-template #clInitialsUd><span class="avatar-initials">{{getUserInitials(User.userName)}}</span></ng-template>
        </span>
        <span class="cl-ud-who">
          <b>{{User.userName}}</b>
          <small *ngIf="User.designation">{{User.designation}}</small>
        </span>
      </div>
      <dl class="cl-ud-kv" *ngIf="User.emailId || currentBranchName">
        <div *ngIf="User.emailId"><dt>Email</dt><dd [title]="User.emailId">{{User.emailId}}</dd></div>
        <div *ngIf="currentBranchName"><dt>Branch</dt><dd class="hl">{{currentBranchName}}</dd></div>
      </dl>

      <div class="cl-ud-grp">Account</div>
      <a (click)="openMyAccount(); closeUserDropdown()" class="dropdown-item notify-item" style="cursor: pointer;">
        <i class="mdi mdi-account-circle"></i>
        <span>My Account</span>
      </a>
      <a [routerLink]="['/settings']" (click)="closeUserDropdown()" class="dropdown-item notify-item"
        style="cursor: pointer;">
        <i class="mdi mdi-cog-outline"></i>
        <span>Settings</span>
      </a>

      <div class="cl-ud-grp">Workspace</div>
      <a (click)="changeBranch(); closeUserDropdown()" class="dropdown-item notify-item" *ngIf="BranchList.length > 1"
        style="cursor: pointer;">
        <i class="mdi mdi-source-branch"></i>
        <span>Change Branch</span>
      </a>
      <a (click)="openHelpSupport(); closeUserDropdown()" class="dropdown-item notify-item" style="cursor: pointer;">
        <i class="mdi mdi-headset"></i>
        <span>Help &amp; Support</span>
      </a>
      <a (click)="checkForUpdates()" class="dropdown-item notify-item" style="cursor: pointer;">
        <i class="mdi mdi-update"></i>
        <span *ngIf="appUpdate.updateAvailable$ | async; else checkLabel" class="fw-bold text-success">Update available - Reload</span>
        <ng-template #checkLabel><span>{{ updateCheckMsg || 'Check for updates' }}</span></ng-template>
      </a>

      <div class="cl-ud-foot">
        <a (click)="Logout(); closeUserDropdown()" class="dropdown-item notify-item cl-ud-logout" style="cursor: pointer;">
          <i class="mdi mdi-logout"></i>
          <span>Logout</span>
        </a>
      </div>
    </div>
  </ng-container>

  <!-- ============================================================== -->
  <!-- Start Page Content here -->
  <!-- ============================================================== -->

  <div class="content-page">
    <!-- Topbar Start -->
    <div class="navbar-custom">



      <ul class="list-unstyled topbar-menu float-end mb-0">
        <!-- < 992px: opens the same menu search as the desktop header button -->
        <li class="d-flex align-items-center d-lg-none ms-auto" style="height:70px;">
          <button type="button" class="cl-icon-btn" (click)="openCmd()" title="Search menu" aria-label="Search menu">
            <i class="bi bi-search"></i>
          </button>
        </li>

        <li class="d-flex align-items-center" style="height:70px; margin-left:6px; margin-right:0;">
          <div class="header-custom-slot d-flex align-items-center"></div>
        </li>

        <li class="d-flex align-items-center" style="height:70px; margin-left:0; margin-right:14px;">
          <app-notification-bell></app-notification-bell>
        </li>

        <!-- user menu trigger for the < 992px top bar (the >= 992px row below has its own) -->
        <li class="d-flex align-items-center" style="height:70px; margin-right:10px;">
          <a class="cl-user-btn cl-user-mini" href="#" role="button" (click)="toggleHeaderUserDropdown($event)"
            [class.active]="userDropdownOpen" title="{{User.userName}}">
            <span class="cl-avatar">
              <img *ngIf="User.profileImage; else clInitialsMini" [src]="User.profileImage" (error)="onImageError($event)" alt="User Profile" />
              <ng-template #clInitialsMini><span class="avatar-initials rounded-circle">{{getUserInitials(User.userName)}}</span></ng-template>
            </span>
          </a>
        </li>

      </ul>
      <button class="button-menu-mobile open-left d-md-none">
        <i class="mdi mdi-menu"></i>
      </button>

    </div>

    <div class="content container-fluid p-1">
      <!-- end Topbar -->
      <div class="topbar-breadcrumb d-none d-lg-flex">
        <div class="topbar-breadcrumb-trail">
          <ng-container *ngFor="let crumb of breadcrumbItems; let isLast = last; let isFirst = first">
            <a *ngIf="crumb.clickable; else staticBreadcrumb" class="breadcrumb-link"
              (click)="navigateToBreadcrumb(crumb)">
              {{ crumb.label }}
            </a>

            <ng-template #staticBreadcrumb>
              <span class="breadcrumb-current" [class.breadcrumb-parent-context]="isFirst">
                {{ crumb.label }}
              </span>
            </ng-template>

            <i class="bi bi-chevron-right breadcrumb-separator" *ngIf="!isLast" aria-hidden="true"></i>
          </ng-container>
        </div>

        <button type="button" class="cl-search-btn" (click)="openCmd()" title="Search menu (Ctrl+K)">
          <i class="bi bi-search"></i><span class="cl-t">Search or jump to...</span><kbd>Ctrl K</kbd>
        </button>

        <button type="button" class="topbar-branch-switcher" (click)="changeBranch()" *ngIf="currentBranchName && BranchList.length > 1">
          <i class="mdi mdi-source-branch me-1"></i>
          <span class="topbar-branch-label">{{ currentBranchName }}</span>
          <i class="mdi mdi-chevron-down ms-1"></i>
        </button>

        <!-- Custom HTML slot (MasterType /global/header, ParentDivId .header-custom-slot): e.g. the header calculator -->
        <div class="header-custom-slot d-flex align-items-center"></div>

        <app-notification-bell></app-notification-bell>

        <!-- Clarity look: the user menu now lives at the top right (same dropdown and handlers as the sidebar one) -->
        <a class="cl-user-btn" href="#" role="button" (click)="toggleHeaderUserDropdown($event)"
          [class.active]="userDropdownOpen">
          <span class="cl-avatar">
            <img *ngIf="User.profileImage; else clInitials" [src]="User.profileImage" (error)="onImageError($event)" alt="User Profile" />
            <ng-template #clInitials><span class="avatar-initials rounded-circle">{{getUserInitials(User.userName)}}</span></ng-template>
          </span>
          <span class="cl-user-text">
            <span class="cl-user-name">{{User.userName}}</span>
            <span class="cl-user-pos" *ngIf="User.designation">{{User.designation}}</span>
          </span>
          <i class="mdi mdi-chevron-down cl-caret"></i>
        </a>
      </div>

      <!-- Mobile Breadcrumb Strip (visible only on < lg screens) -->
      <div class="mobile-breadcrumb-bar d-lg-none" [class.bc-hidden]="mobileBreadcrumbHidden"
        *ngIf="breadcrumbItems.length > 0">
        <ng-container *ngFor="let crumb of breadcrumbItems; let isLast = last; let isFirst = first">
          <a *ngIf="crumb.clickable; else mobileStaticCrumb" class="breadcrumb-link"
            (click)="navigateToBreadcrumb(crumb)">
            {{ crumb.label }}
          </a>
          <ng-template #mobileStaticCrumb>
            <span class="breadcrumb-current" [class.breadcrumb-parent-context]="isFirst">
              {{ crumb.label }}
            </span>
          </ng-template>
          <i class="bi bi-chevron-right breadcrumb-separator" *ngIf="!isLast" aria-hidden="true"></i>
        </ng-container>
      </div>

      <!-- Start Content-->

      <!-- Payment Due Popup Modal -->
      <ng-container *ngIf="activePaymentDueAlert">

        <!-- ── Phase 1: Soft payment reminder (blue) ──────────────────── -->
        <ng-container *ngIf="activePaymentDueAlert.paymentPhase === 1">
          <div class="adv-payment-overlay" (click)="dismissPaymentPopup()">
            <div class="adv-payment-modal" (click)="$event.stopPropagation()">
              <div class="adv-payment-header soft" style="display:flex;align-items:flex-start;justify-content:space-between;">
                <div>
                  <h2 style="margin:0 0 4px;">Payment Reminder</h2>
                  <p style="margin:0;opacity:.9;">Subscription payment pending</p>
                </div>
                <button class="close-btn" (click)="dismissPaymentPopup()">&#x2715;</button>
              </div>
              <div class="adv-payment-body">
                <div class="left">
                  <div class="status-pill">Advance Payment Notice</div>
                  <h3 style="margin:0 0 10px;font-size:15px;">Dear Customer,</h3>
                  <p>This is a gentle reminder that your current billing cycle payment is pending.
                    We request you to kindly complete the payment at the earliest to ensure smooth service continuity.</p>
                  <p>Please note that manual support may be discontinued from the <strong>5th of this month</strong>
                    in case payment remains unpaid.</p>
                  <div class="amount-grid">
                    <div class="card"><label>Expiry Date</label><strong>{{ activePaymentDueAlert.endDate | date:'dd MMM yyyy' }}</strong></div>
                    <div class="card"><label>Days Overdue</label><strong style="color:#dc2626;">{{ activePaymentDueAlert.overdueDays }} day{{ activePaymentDueAlert.overdueDays === 1 ? '' : 's' }}</strong></div>
                    <div class="card"><label>Amount Due</label><strong>&#x20B9;{{ activePaymentDueAlert.monthlyTotalAmount | number:'1.0-0' }}</strong></div>
                  </div>
                </div>
                <div class="right">
                  <div class="qr-box">
                    <img [src]="paymentQrCodeUrl" alt="UPI Payment QR Code" />
                  </div>
                  <p style="font-size:12px;color:#64748b;margin:6px 0 8px;text-align:center;">Scan QR to pay via UPI</p>
                  <div class="pay-upi-row">
                    <span class="pay-upi-id">{{ paymentBankDetails.upiId }}</span>
                    <button class="pay-copy-btn" title="Copy UPI ID" (click)="copyPaymentField(paymentBankDetails.upiId, 'upi')">
                      <i [class]="copiedPaymentField === 'upi' ? 'mdi mdi-check text-success' : 'mdi mdi-content-copy'"></i>
                    </button>
                  </div>
                  <button class="pay-bank-toggle" (click)="showPaymentBankDetails = !showPaymentBankDetails">
                    {{ showPaymentBankDetails ? 'Hide' : 'Show' }} Bank Details
                    <i [class]="showPaymentBankDetails ? 'mdi mdi-chevron-up ms-1' : 'mdi mdi-chevron-down ms-1'"></i>
                  </button>
                  <ng-container *ngTemplateOutlet="bankDetailsBlock"></ng-container>
                  <div style="margin-top:12px;display:flex;gap:8px;flex-wrap:wrap;justify-content:center;">
                    <button class="btn secondary" (click)="dismissPaymentPopup()">I Acknowledge</button>
                    <a class="btn primary" href="mailto:support@advinsoftwares.com">Contact Support</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- ── Phase 2: Warning (amber) ───────────────────────────────── -->
        <ng-container *ngIf="activePaymentDueAlert.paymentPhase === 2">
          <div class="popup-backdrop" (click)="dismissPaymentPopup()">
            <div class="popup-card" (click)="$event.stopPropagation()">
              <div class="banner warning" style="display:flex;align-items:center;justify-content:space-between;">
                <div style="display:flex;align-items:center;gap:14px;">
                  <div style="font-size:28px;">&#x26A0;</div>
                  <div>
                    <h2 style="margin:0 0 2px;">Important Payment Notice</h2>
                    <p style="margin:0;opacity:.9;">Action required to avoid service impact</p>
                  </div>
                </div>
                <button class="close-btn" (click)="dismissPaymentPopup()">&#x2715;</button>
              </div>
              <div class="content-wrap">
                <div class="message-panel">
                  <p>Our records indicate that your payment for the current cycle is still pending.</p>
                  <p>Manual support has been discontinued due to non-payment. Kindly complete payment
                    urgently to avoid application discontinuation after the <strong>25th of this month</strong>.</p>
                  <div class="summary-row">
                    <div><span>Expiry Date</span><strong>{{ activePaymentDueAlert.endDate | date:'dd MMM yyyy' }}</strong></div>
                    <div><span>Days Overdue</span><strong style="color:#dc2626;">{{ activePaymentDueAlert.overdueDays }} day{{ activePaymentDueAlert.overdueDays === 1 ? '' : 's' }}</strong></div>
                    <div><span>Amount Due</span><strong>&#x20B9;{{ activePaymentDueAlert.monthlyTotalAmount | number:'1.0-0' }}</strong></div>
                  </div>
                </div>
                <div class="payment-panel">
                  <img [src]="paymentQrCodeUrl" alt="QR Code" class="qr-img" />
                  <div class="pay-upi-row" style="margin:8px 0 6px;">
                    <span class="pay-upi-id">{{ paymentBankDetails.upiId }}</span>
                    <button class="pay-copy-btn" title="Copy UPI ID" (click)="copyPaymentField(paymentBankDetails.upiId, 'upi')">
                      <i [class]="copiedPaymentField === 'upi' ? 'mdi mdi-check text-success' : 'mdi mdi-content-copy'"></i>
                    </button>
                  </div>
                  <button class="pay-bank-toggle" (click)="showPaymentBankDetails = !showPaymentBankDetails">
                    {{ showPaymentBankDetails ? 'Hide' : 'Show' }} Bank Details
                    <i [class]="showPaymentBankDetails ? 'mdi mdi-chevron-up ms-1' : 'mdi mdi-chevron-down ms-1'"></i>
                  </button>
                  <ng-container *ngTemplateOutlet="bankDetailsBlock"></ng-container>
                  <div style="display:flex;gap:8px;flex-wrap:wrap;justify-content:center;margin-top:10px;">
                    <a class="btn primary" href="mailto:support@advinsoftwares.com">Contact Support</a>
                    <button class="btn ghost" (click)="dismissPaymentPopup()">I Acknowledge</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- ── Phase 3+: Critical (red) ───────────────────────────────── -->
        <ng-container *ngIf="activePaymentDueAlert.paymentPhase >= 3">
          <div class="critical-overlay" (click)="dismissPaymentPopup()">
            <div class="critical-modal" (click)="$event.stopPropagation()">
              <div class="critical-header" style="display:flex;align-items:center;justify-content:space-between;">
                <div>
                  <h2 style="margin:0 0 2px;">Urgent: Payment Pending</h2>
                  <p style="margin:0;opacity:.9;font-size:13px;">Immediate action required</p>
                </div>
                <button class="close-btn" (click)="dismissPaymentPopup()">&#x2715;</button>
              </div>
              <div class="critical-body">
                <div class="critical-message">
                  <p>Your subscription payment is still pending.</p>
                  <p>Manual support is already discontinued. Continued non-payment may lead to
                    discontinuation of application access as well.</p>
                  <p>Please complete payment <strong>immediately</strong> using the QR code or contact support below.</p>
                  <div class="amount-grid">
                    <div class="card"><label>Expiry Date</label><strong>{{ activePaymentDueAlert.endDate | date:'dd MMM yyyy' }}</strong></div>
                    <div class="card"><label>Days Overdue</label><strong style="color:#dc2626;">{{ activePaymentDueAlert.overdueDays }} day{{ activePaymentDueAlert.overdueDays === 1 ? '' : 's' }}</strong></div>
                    <div class="card"><label>Amount Due</label><strong>&#x20B9;{{ activePaymentDueAlert.monthlyTotalAmount | number:'1.0-0' }}</strong></div>
                  </div>
                </div>
                <div class="critical-payment">
                  <img [src]="paymentQrCodeUrl" alt="Payment QR" />
                  <div class="pay-upi-row" style="margin:8px 0 6px;">
                    <span class="pay-upi-id">{{ paymentBankDetails.upiId }}</span>
                    <button class="pay-copy-btn" title="Copy UPI ID" (click)="copyPaymentField(paymentBankDetails.upiId, 'upi')">
                      <i [class]="copiedPaymentField === 'upi' ? 'mdi mdi-check text-success' : 'mdi mdi-content-copy'"></i>
                    </button>
                  </div>
                  <button class="pay-bank-toggle" (click)="showPaymentBankDetails = !showPaymentBankDetails">
                    {{ showPaymentBankDetails ? 'Hide' : 'Show' }} Bank Details
                    <i [class]="showPaymentBankDetails ? 'mdi mdi-chevron-up ms-1' : 'mdi mdi-chevron-down ms-1'"></i>
                  </button>
                  <ng-container *ngTemplateOutlet="bankDetailsBlock"></ng-container>
                  <div style="display:flex;flex-wrap:wrap;gap:8px;justify-content:center;margin-top:10px;">
                    <a class="btn pay" href="mailto:support@advinsoftwares.com">Contact Support</a>
                    <button class="btn close" (click)="dismissPaymentPopup()">Close</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Shared bank details block (rendered inside each phase via ngTemplateOutlet) -->
        <ng-template #bankDetailsBlock>
          <div class="pay-bank-details" *ngIf="showPaymentBankDetails">
            <div class="pay-bank-row"><span>Beneficiary</span><span>{{ paymentBankDetails.beneficiary }}</span></div>
            <div class="pay-bank-row">
              <span>Account No</span>
              <span class="d-flex align-items-center gap-1">{{ paymentBankDetails.accountNo }}
                <button class="pay-copy-btn sm" (click)="copyPaymentField(paymentBankDetails.accountNo, 'acc')"><i [class]="copiedPaymentField === 'acc' ? 'mdi mdi-check text-success' : 'mdi mdi-content-copy'"></i></button>
              </span>
            </div>
            <div class="pay-bank-row"><span>Bank</span><span>{{ paymentBankDetails.bankName }}</span></div>
            <div class="pay-bank-row">
              <span>IFSC</span>
              <span class="d-flex align-items-center gap-1">{{ paymentBankDetails.ifscCode }}
                <button class="pay-copy-btn sm" (click)="copyPaymentField(paymentBankDetails.ifscCode, 'ifsc')"><i [class]="copiedPaymentField === 'ifsc' ? 'mdi mdi-check text-success' : 'mdi mdi-content-copy'"></i></button>
              </span>
            </div>
            <div class="pay-bank-row"><span>GSTIN</span><span>{{ paymentBankDetails.gstin }}</span></div>
          </div>
        </ng-template>

      </ng-container>

      <router-outlet></router-outlet>
    </div>
  </div>

  <!-- ============================================================== -->
  <!-- End Page content -->
  <!-- ============================================================== -->
</div>
<!-- END wrapper -->

<app-support-chat-widget></app-support-chat-widget>



<!-- Branch Selection Modal -->

<ng-template #branchModal>
  <div class="modal-header cl-bm-head">
    <div class="cl-bm-title">
      <span class="cl-bm-ico"><i class="mdi mdi-source-branch"></i></span>
      <div>
        <h5 class="modal-title">Select Branch</h5>
        <small>Choose the branch you want to work in.</small>
      </div>
    </div>
    <button type="button" class="btn-close" (click)="closeBranchModal()"></button>
  </div>
  <div class="modal-body cl-bm-body">
    <div class="branch-grid">
      <button type="button" class="branch-card" *ngFor="let branch of BranchList" (click)="selectBranch(branch)"
        [class.active-branch]="branch.tenantBranchId  === User.loggedInBranchId"
        [class.default-branch]="branch.isDefault === 1">
        <div class="branch-card-main">
          <span class="branch-icon-chip">
            <i class="mdi mdi-domain"></i>
          </span>
          <div class="branch-card-content">
            <div class="branch-card-head">
              <span class="branch-code">{{ branch.branchCode }}</span>
            </div>
            <div class="branch-name">{{ branch.branchName }}</div>
          </div>
          <span class="branch-badge branch-badge-mid" *ngIf="branch.isDefault === 1">Default</span>
          <span class="branch-badge branch-badge-success"
            *ngIf="branch.tenantBranchId  === User.loggedInBranchId">Active</span>
          <span class="branch-forward">
            <i class="mdi mdi-chevron-right"></i>
          </span>
        </div>
      </button>
    </div>
  </div>
</ng-template>